import {
  TDeliveryMethod,
  TPaymentMethod,
  TShippingFormData,
} from './Checkout.types';

export const SHIPPING_FORM_DEFAULT_VALUES: TShippingFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  street: '',
  buildingNumber: '',
  apartmentNumber: '',
  city: '',
  postalCode: '',
  additionalInfo: '',
  deliveryMethod: 'inpost',
  parcelLockerCode: '',
};

export const CHECKOUT_STEPS = [
  { id: 'cart', label: 'Cart Review', step: 1 },
  { id: 'shipping', label: 'Shipping', step: 2 },
  { id: 'payment', label: 'Payment', step: 3 },
] as const;

export const DELIVERY_METHODS: Array<{
  id: TDeliveryMethod;
  name: string;
  description: string;
  price: number;
  estimatedDays: string;
  icon?: string;
}> = [
  {
    id: 'inpost',
    name: 'InPost',
    description: 'Paczkomaty 24/7',
    price: 0,
    estimatedDays: '1-2 dni',
  },
];

export const PAYMENT_METHODS: Array<{
  id: TPaymentMethod;
  name: string;
  description: string;
  icon?: string;
}> = [
  {
    id: 'card',
    name: 'Karta płatnicza',
    description: 'Visa, Mastercard',
  },
  // {
  //   id: 'blik',
  //   name: 'BLIK',
  //   description: 'Płatność BLIK',
  // },
  // {
  //   id: 'transfer',
  //   name: 'Przelew bankowy',
  //   description: 'Przelew tradycyjny',
  // },
  // {
  //   id: 'cash',
  //   name: 'Za pobraniem',
  //   description: 'Płatność przy odbiorze',
  // },
];
